"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._b({
    staticClass: "app-nicklist-user",
    class: {
      'app-nicklist-user--away': _vm.user.isAway() || _vm.user.isOffline(),
      'app-nicklist-user--ignore': _vm.user.ignore,
      'app-nicklist-user--male': _vm.aslSexClass === 'male',
      'app-nicklist-user--female': _vm.aslSexClass === 'female'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.isServiceBot || _vm.nicklist.openUserbox(_vm.user);
      }
    }
  }, 'div', _vm.dataAttributes, false), [_vm.nicklist.shouldShowAvatars ? _c('div', {
    staticClass: "app-nicklist-avatar"
  }, [_vm.isServiceBot ? _c('svg', {
    staticClass: "app-avatar app-nicklist-robot",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "app-nicklist-robot-bg",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50"
    }
  }), _c('g', {
    attrs: {
      "transform": "translate(50 43.5) scale(1.15) translate(-50 -43.5)"
    }
  }, [_c('circle', {
    staticClass: "app-nicklist-robot-body",
    attrs: {
      "cx": "50",
      "cy": "20",
      "r": "5"
    }
  }), _c('rect', {
    staticClass: "app-nicklist-robot-body",
    attrs: {
      "x": "47.5",
      "y": "22",
      "width": "5",
      "height": "11",
      "rx": "2"
    }
  }), _c('rect', {
    staticClass: "app-nicklist-robot-body",
    attrs: {
      "x": "20",
      "y": "46",
      "width": "6",
      "height": "16",
      "rx": "3"
    }
  }), _c('rect', {
    staticClass: "app-nicklist-robot-body",
    attrs: {
      "x": "74",
      "y": "46",
      "width": "6",
      "height": "16",
      "rx": "3"
    }
  }), _c('rect', {
    staticClass: "app-nicklist-robot-body",
    attrs: {
      "x": "28",
      "y": "32",
      "width": "44",
      "height": "40",
      "rx": "10"
    }
  }), _c('circle', {
    staticClass: "app-nicklist-robot-face",
    attrs: {
      "cx": "41",
      "cy": "50",
      "r": "6"
    }
  }), _c('circle', {
    staticClass: "app-nicklist-robot-face",
    attrs: {
      "cx": "59",
      "cy": "50",
      "r": "6"
    }
  }), _c('rect', {
    staticClass: "app-nicklist-robot-face",
    attrs: {
      "x": "39",
      "y": "61",
      "width": "22",
      "height": "5",
      "rx": "2.5"
    }
  })])]) : _c('UserAvatar', _vm._b({
    attrs: {
      "user": _vm.user,
      "network": _vm.network,
      "size": "small"
    }
  }, 'UserAvatar', _vm.nicklist.avatarProps, false))], 1) : _c('AwayStatusIndicator', {
    staticClass: "app-nicklist-awaystatus",
    attrs: {
      "network": _vm.network,
      "user": _vm.user,
      "toggle": false
    }
  }), _c('div', {
    staticClass: "app-nicklist-user-main"
  }, [_c('div', {
    staticClass: "app-nicklist-user-nick-wrap"
  }, [_c('span', {
    staticClass: "app-nicklist-user-nick",
    style: {
      color: _vm.userColour
    }
  }, [_vm._v(_vm._s(_vm.displayNick))]), _vm.isSelf ? _c('span', {
    staticClass: "app-nicklist-you-badge"
  }, [_vm._v("VOUS")]) : _vm._e(), _vm.modeBadge ? _c('span', {
    class: `app-mode-badge app-mode-badge--${_vm.modeBadge.key}`
  }, [_vm._v(_vm._s(_vm.modeBadge.label))]) : _vm._e()]), _vm.specialSubtitle ? _c('div', {
    staticClass: "app-nicklist-user-meta app-nicklist-user-meta--subtitle"
  }, [_c('span', {
    staticClass: "app-nicklist-user-meta-item app-nicklist-user-meta-location"
  }, [_vm._v(_vm._s(_vm.specialSubtitle))])]) : _vm.aslMetaLine ? _c('div', {
    staticClass: "app-nicklist-user-meta"
  }, [_vm.aslAge ? _c('span', {
    staticClass: "app-nicklist-user-meta-item"
  }, [_vm._v(_vm._s(_vm.aslAge))]) : _vm._e(), _vm.aslSexLabel ? _c('span', {
    staticClass: "app-nicklist-user-meta-item",
    class: `app-nicklist-user-meta-sex app-nicklist-user-meta-sex--${_vm.aslSexClass}`
  }, [_vm._v(_vm._s(_vm.aslSexLabel))]) : _vm._e(), _vm.aslLocation ? _c('span', {
    staticClass: "app-nicklist-user-meta-item app-nicklist-user-meta-location"
  }, [_vm._v(_vm._s(_vm.aslLocation))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "app-nicklist-user-buttons"
  }, [_c('svg', {
    staticClass: "app-nicklist-user-typing",
    class: {
      'app-nicklist-user-typing--active': _vm.userTypingState === 'active',
      'app-nicklist-user-typing--paused': _vm.userTypingState === 'paused'
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "4",
      "cy": "12",
      "r": "3"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  }), _c('circle', {
    attrs: {
      "cx": "20",
      "cy": "12",
      "r": "3"
    }
  })]), _c('svg', {
    staticClass: "app-nicklist-user-message",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 36 36"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.nicklist.openQuery(_vm.user);
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 1C8.059 1 0 7.268 0 15c0 4.368 2.574 8.268 6.604 10.835C6.08 28.144\n                    4.859 31.569 2 35c5.758-.96 9.439-3.761 11.716-6.416c1.376.262 2.805.416\n                    4.284.416c9.941 0 18-6.268 18-14S27.941 1 18 1z"
    }
  })])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];